import { post } from 'axios';
import { FEEDBACK_URL } from '../config/constants';

// eslint-disable-next-line import/prefer-default-export
export const submitFeedback = (payload) => {
  return post(FEEDBACK_URL, payload).then(
    (response) => response.data,
    (err) => {
      const status = err?.response?.status;
      const message = err?.response?.data?.result;
      const error = new Error(message);
      error.status = status;
      throw error;
    },
  );
};
